import { Box, Typography, Link } from '@mui/material'
import { COLORS } from '../../constants/colors'
import { TEXT } from '../../constants/text'

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 3,
        px: 3,
        borderTop: `1px solid ${COLORS.border.subtle}`,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
      }}
    >
      {/* Left */}
      <Typography sx={{ fontSize: '0.7rem', color: COLORS.text.muted }}>
        © {new Date().getFullYear()} {TEXT.BUSINESS.NAME} — {TEXT.FOOTER.NON_CUSTODIAL}
      </Typography>

      {/* Links */}
      <Box sx={{ display: 'flex', gap: 2 }}>
        {[
          { label: TEXT.FOOTER.TERMS, key: 'terms' },
          { label: TEXT.FOOTER.PRIVACY, key: 'privacy' },
          { label: TEXT.FOOTER.STATUS, href: '#' },
        ].map((l) => (
          <Link
            key={l.label}
            href={l.href || '#'}
            underline="hover"
            sx={{
              fontSize: '0.7rem',
              color: COLORS.text.muted,
              cursor: 'pointer',
              '&:hover': { color: COLORS.gold.primary },
            }}
          >
            {l.label}
          </Link>
        ))}
      </Box>
    </Box>
  )
}
